import axios from '@/utils/axios';

// 获取套餐商品列表
export function PackageListByCity(params) {
    return axios({
        url: '/package/list',
        method: 'get',
        params,
    });
}

// 套餐商品详情
export function PackageDetail(params) {
    return axios({
        url: '/package',
        method: 'get',
        params,
    });
}